import { render, staticRenderFns } from "./media-avatar-academica.vue?vue&type=template&id=0fe159de&"
import script from "./media-avatar-academica.vue?vue&type=script&lang=js&"
export * from "./media-avatar-academica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports